import React from 'react'
import Layout from '../../components/LayoutNew'
import { graphql, useStaticQuery } from 'gatsby'
import HomeSection3 from '../../containers/HomeSection3'
import ProductSection1 from '../../containers/ProductSection1'
import ProductSection2 from '../../containers/ProductSection2'
import { Fragment } from 'react'
import Img from 'gatsby-image'

import './openshop.scss'

const OpenShopPage = () => {
  const pageColor = '#1671D8'
  const { openShop0, openShop1, openShop2 } = useStaticQuery(graphql`
    query {
      openShop0: file(
        relativePath: { eq: "products/openshop/openshop-0.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      openShop1: file(
        relativePath: { eq: "products/openshop/openshop-1.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      openShop2: file(
        relativePath: { eq: "products/openshop/openshop-2.png" }
      ) {
        id
        childImageSharp {
          fluid(maxWidth: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Layout
      className="openshop-page"
      headerBackground={pageColor}
      headerTheme="white"
    >
      <ProductSection1
        className="section-0"
        background={pageColor}
        title="从零到一，手把手解决开店难题"
        subTitle="再惠为商家提供本地生活平台开店服务，针对品牌特性定制专业解决方案，解决商家迫在眉睫的难题"
      />
      <ProductSection2
        className="section-1"
        title="商户自有私域平台"
        subTitle="依托微信公众号，为品牌搭建自有的小程序模块，打通微信会员系统与点餐系统，助力品牌及时掌握消费者情况，构建自有私域流量池"
        image={
          <div style={{ width: '522px' }}>
            <Img
              fluid={openShop0.childImageSharp.fluid}
              alt="商户自有私域平台"
            />
          </div>
        }
      />
      <ProductSection2
        className="section-2"
        type="row-reverse"
        title="迭代品牌经营方针"
        subTitle="对品牌已有店铺进行全面诊断，针对本地生活平台页面菜单栏、banner展现、套餐设定等内容提出翻新建议，提高用户点击兴趣，全方位提高品牌进店率，优化店铺消费转化率"
        image={
          <div style={{ width: '522px' }}>
            <Img
              fluid={openShop1.childImageSharp.fluid}
              alt="迭代品牌经营方针"
            />
          </div>
        }
      />
      <ProductSection2
        className="section-3"
        title="及时获取店铺经营情况"
        subTitle="借助大数据分析系统，及时了解品牌营业期间展现的问题，做出诊断分析"
        image={
          <div style={{ width: '522px' }}>
            <Img
              fluid={openShop2.childImageSharp.fluid}
              alt="及时获取店铺经营情况"
            />
          </div>
        }
      />
      <HomeSection3 />
    </Layout>
  )
}

export default OpenShopPage
